var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticStyle: { padding: "0 40px" } },
        [
          _c("span", { staticClass: "title-h4" }, [
            _vm._v(_vm._s(_vm.$t("importCargoInfo.title"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("importCargoInfo.blNo"),
                            prop: "blNo",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("placeholder.blNo"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.blNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "blNo", $$v)
                              },
                              expression: "form.blNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("importCargoInfo.containerNo"),
                            prop: "containerNo",
                            "label-width": "110px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("placeholder.containerNo"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.containerNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "containerNo", $$v)
                              },
                              expression: "form.containerNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "30px" },
                      attrs: { span: 6 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary" },
                          on: { click: _vm.toSearch },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.search")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", { staticClass: "warm-tips" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("importCargoInfo.tips_1"))
                ),
                _c("br"),
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("importCargoInfo.tips_2"))
                ),
                _c("br"),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("importCargoInfo.tips_3")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "result-container" },
      [
        _vm.showResult
          ? _c(
              "el-tabs",
              { attrs: { type: "border-card" } },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: _vm.$t("importCargoInfo.cargoInfo") } },
                  [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("importCargoInfo.baseInfo"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "font-size": "12px" } },
                      [
                        _c(
                          "el-row",
                          { attrs: { type: "flex", justify: "center" } },
                          [
                            _c("el-col", { attrs: { span: 4 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("importCargoInfo.vesselName"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _vm._v(_vm._s(_vm.baseData.vesselName)),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("importCargoInfo.voyageNo"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _vm._v(_vm._s(_vm.baseData.voyageNo)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex", justify: "center" } },
                          [
                            _c("el-col", { attrs: { span: 4 } }, [
                              _vm._v(_vm._s(_vm.$t("importCargoInfo.pol"))),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _vm._v(_vm._s(_vm.baseData.pol)),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _vm._v(_vm._s(_vm.$t("importCargoInfo.pod"))),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _vm._v(_vm._s(_vm.baseData.pod)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex", justify: "center" } },
                          [
                            _c("el-col", { attrs: { span: 4 } }, [
                              _vm._v(_vm._s(_vm.$t("importCargoInfo.eta"))),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _vm._v(_vm._s(_vm.baseData.eta)),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("importCargoInfo.actualEndTime"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _vm._v(_vm._s(_vm.baseData.actualWordEndTime)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex", justify: "center" } },
                          [
                            _c("el-col", { attrs: { span: 4 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("importCargoInfo.releaseStatus"))
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.baseData.releaseStatus == 1 ||
                            _vm.baseData.releaseStatus == 2 ||
                            _vm.baseData.releaseStatus == 3 ||
                            _vm.baseData.releaseStatus == 4
                              ? _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.isCnLang
                                          ? _vm.releaseTypeName[
                                              _vm.baseData.releaseStatus
                                            ]
                                          : _vm.releaseTypeNameEn[
                                              _vm.baseData.releaseStatus
                                            ]
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : _c("el-col", { attrs: { span: 8 } }),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("importCargoInfo.changeStatus"))
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.baseData.deliveryReleaseFlag == 0 ||
                            _vm.baseData.deliveryReleaseFlag == 1 ||
                            _vm.baseData.deliveryReleaseFlag == 2
                              ? _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.changeTypeName[
                                          _vm.baseData.deliveryReleaseFlag
                                        ]
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : _c("el-col", { attrs: { span: 8 } }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !this.validateNull(_vm.baseData.exchahgerRate)
                          ? _c(
                              "el-row",
                              { attrs: { type: "flex", justify: "center" } },
                              [
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("importCargoInfo.takeContainer")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.baseData.takeContainerLoc) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("importCargoInfo.rate"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.baseData.exchahgerRate) +
                                      "\n            "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _c(
                              "el-row",
                              { attrs: { type: "flex", justify: "center" } },
                              [
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("importCargoInfo.takeContainer")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 20 } }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.baseData.takeContainerLoc) +
                                      "\n            "
                                  ),
                                ]),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("importCargoInfo.containerInfo"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.tableContainerData,
                          border: "",
                          size: "small",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "index", width: "40" },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "containerNo",
                            label: _vm.$t("importCargoInfo.containerNo"),
                            "min-width": "18%",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "containerType",
                            label: _vm.$t("importCargoInfo.containerType"),
                            "min-width": "8%",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            label: _vm.$t("importCargoInfo.quantity"),
                            "min-width": "8%",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "weight",
                            label: _vm.$t("importCargoInfo.weight"),
                            "min-width": "10%",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cntrSize",
                            label: _vm.$t("importCargoInfo.size"),
                            "min-width": "10%",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "demFromDate",
                            label: _vm.$t("importCargoInfo.uploadDate"),
                            "min-width": "11%",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "demToDate",
                            label: _vm.$t("importCargoInfo.demToDate"),
                            "min-width": "11%",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              prop: "demFreeDays",
                              label: _vm.$t("importCargoInfo.FreeDays"),
                              "min-width": "11%",
                            },
                          },
                          [
                            [
                              _c(
                                "el-link",
                                {
                                  staticStyle: { "font-size": "12px" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleBLNo(_vm.form.blNo)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.isCnLang ? "详情" : "detail") +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { label: _vm.$t("importCargoInfo.importFee") } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "80%" },
                        attrs: {
                          data: _vm.tableFeeData,
                          border: "",
                          "show-summary": "",
                          "summary-method": _vm.getSummaries,
                          size: "small",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "chargeCode",
                            label: _vm.$t("importCargoInfo.chargeCode"),
                            "min-width": "30%",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "amount",
                            label: _vm.$t("importCargoInfo.amount"),
                            "min-width": "30%",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "currency",
                            label: _vm.$t("importCargoInfo.currency"),
                            "min-width": "20%",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }